/* Decant Diaries — Shopify Theme JavaScript */
/* Generated from decantdiaries.in single-page site */

// ─── PRODUCT DATA ───
// Products are injected from Shopify via snippets/product-data.liquid
// The `products` array is defined in a <script> tag in the layout before this file loads.
// If no Shopify products are loaded (e.g. during development), use empty array as fallback.
if (typeof products === 'undefined') { var products = []; }

// Brand website domains for Google Favicon API (128px)
const brandDomains = {
  'Amouage':'amouage.com','Azzaro':'azzaro.com','BDK Parfums Paris':'bdkparfums.com',
  'Burberry':'burberry.com','Carolina Herrera':'carolinaherrera.com','Cartier':'cartier.com',
  'Chanel':'chanel.com','Chopard':'chopard.com','Creed':'creedfragrance.com',
  'Dior':'dior.com',
  'Gucci':'gucci.com',
  'Guerlain':'guerlain.com','Hermès':'hermes.com','Hugo Boss':'hugoboss.com',
  'Kenzo':'kenzo.com',
  'Kilian Paris':'bykilian.com','Maison Francis Kurkdjian':'franciskurkdjian.com',
  'Mugler':'mugler.com',
  'Nicolaï Parfumeur-Créateur':'nicolaiparis.com',
  'Nishane':'nishane.com','Pantheon Roma':'pantheonroma.com',
  "Penhaligon's":'penhaligons.com','Prada':'prada.com',
  'Rochas':'rochas.com','Rosendo Mateu':'rosendomateu.com','Salvatore Ferragamo':'ferragamo.com',
  'Serge Lutens':'sergelutens.com','Tom Ford':'tomford.com','Valentino':'valentino.com',
  'Xerjoff':'xerjoff.com','Yves Saint Laurent':'ysl.com',"Viktor&Rolf":'viktor-rolf.com',
  'Armaf':'armaf.com','Afnan':'afnanperfumes.com'
};

// High-quality inline SVG brand logos for brands with poor/missing favicons
const brandSvgLogos = (function() {
  function svg(w,h,content) {
    return "data:image/svg+xml," + encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" width="'+w+'" height="'+h+'" viewBox="0 0 '+w+' '+h+'">'+content+'</svg>');
  }
  function circle(text,fg,bg,fs,fw,ff) {
    fg=fg||'#FAF8F5';bg=bg||'#2C2420';fs=fs||'26';fw=fw||'400';ff=ff||"'Georgia','Times New Roman',serif";
    return svg(80,80,'<circle cx="40" cy="40" r="40" fill="'+bg+'"/><text x="40" y="41" text-anchor="middle" dominant-baseline="central" fill="'+fg+'" font-family='+ff+' font-size="'+fs+'" font-weight="'+fw+'" letter-spacing="1">'+text+'</text>');
  }
  function roundRect(text,fg,bg,fs,fw,ff,ls) {
    fg=fg||'#FAF8F5';bg=bg||'#2C2420';fs=fs||'11';fw=fw||'600';ff=ff||"'Helvetica Neue','Arial',sans-serif";ls=ls||'2';
    return svg(80,80,'<rect width="80" height="80" rx="12" fill="'+bg+'"/><text x="40" y="41" text-anchor="middle" dominant-baseline="central" fill="'+fg+'" font-family='+ff+' font-size="'+fs+'" font-weight="'+fw+'" letter-spacing="'+ls+'">'+text+'</text>');
  }

  return {
    // Emporio Armani — EA initials with eagle-inspired styling
    'Emporio Armani': roundRect('EA','#FAF8F5','#1a1a1a','28','300',"'Georgia',serif",'3'),
    // Giorgio Armani — GA circle monogram
    'Giorgio Armani': svg(80,80,'<rect width="80" height="80" rx="12" fill="#fff"/><circle cx="40" cy="40" r="26" fill="none" stroke="#000" stroke-width="3.5"/><text x="35" y="47" text-anchor="middle" dominant-baseline="central" fill="#000" font-family="\'Georgia\',serif" font-size="28" font-weight="700" letter-spacing="-1">G</text><text x="47" y="41" text-anchor="middle" dominant-baseline="central" fill="#000" font-family="\'Georgia\',serif" font-size="22" font-weight="700" letter-spacing="-1">A</text>'),
    // Ex Nihilo — serif caps on warm taupe
    'Ex Nihilo': svg(80,80,'<rect width="80" height="80" rx="12" fill="#A89888"/><text x="40" y="36" text-anchor="middle" dominant-baseline="central" fill="#fff" font-family="\'Georgia\',\'Times New Roman\',serif" font-size="11" font-weight="400" letter-spacing="3">EX</text><text x="40" y="52" text-anchor="middle" dominant-baseline="central" fill="#fff" font-family="\'Georgia\',\'Times New Roman\',serif" font-size="11" font-weight="400" letter-spacing="2">NIHILO</text>'),
    // French Avenue — gold accent on dark
    'French Avenue': roundRect('FRENCH AVENUE','#D4BC9A','#1a1a1a','7.5','600',"'Helvetica Neue','Arial',sans-serif",'0.8'),
    // Givenchy — geometric 4G pattern
    'Givenchy': svg(80,80,'<rect width="80" height="80" rx="12" fill="#fff"/><g transform="translate(40,38) scale(0.55)"><rect x="-28" y="-28" width="25" height="25" rx="2" fill="#000"/><rect x="3" y="-28" width="25" height="25" rx="2" fill="#000"/><rect x="-28" y="3" width="25" height="25" rx="2" fill="#000"/><rect x="3" y="3" width="25" height="25" rx="2" fill="#000"/><rect x="-18" y="-18" width="10" height="10" rx="1" fill="#fff"/><rect x="8" y="-18" width="10" height="10" rx="1" fill="#fff"/><rect x="-18" y="8" width="10" height="10" rx="1" fill="#fff"/><rect x="8" y="8" width="10" height="10" rx="1" fill="#fff"/><path d="M-15.5,-3 L-3,-3 L-3,-15.5" fill="none" stroke="#000" stroke-width="3.5"/><path d="M15.5,-3 L3,-3 L3,-15.5" fill="none" stroke="#000" stroke-width="3.5"/><path d="M-15.5,3 L-3,3 L-3,15.5" fill="none" stroke="#000" stroke-width="3.5"/><path d="M15.5,3 L3,3 L3,15.5" fill="none" stroke="#000" stroke-width="3.5"/></g><text x="40" y="68" text-anchor="middle" dominant-baseline="central" fill="#000" font-family="\'Helvetica Neue\',sans-serif" font-size="6" font-weight="500" letter-spacing="2.5">GIVENCHY</text>'),
    // Issey Miyake — Japanese minimalism
    'Issey Miyake': svg(80,80,'<rect width="80" height="80" rx="12" fill="#2C2420"/><text x="40" y="32" text-anchor="middle" dominant-baseline="central" fill="#FAF8F5" font-family="\'Helvetica Neue\',sans-serif" font-size="8" font-weight="300" letter-spacing="3">ISSEY</text><text x="40" y="50" text-anchor="middle" dominant-baseline="central" fill="#FAF8F5" font-family="\'Helvetica Neue\',sans-serif" font-size="8" font-weight="300" letter-spacing="3">MIYAKE</text>'),
    // Jean Paul Gaultier — bold JPG
    'Jean Paul Gaultier': svg(80,80,'<rect width="80" height="80" rx="12" fill="#1a1a1a"/><text x="40" y="36" text-anchor="middle" dominant-baseline="central" fill="#FAF8F5" font-family="\'Georgia\',serif" font-size="22" font-weight="700" letter-spacing="1">JPG</text><text x="40" y="56" text-anchor="middle" dominant-baseline="central" fill="#999" font-family="\'Helvetica Neue\',sans-serif" font-size="5.5" font-weight="400" letter-spacing="1.5">GAULTIER</text>'),
    // Mancera — luxury gold M
    'Mancera': svg(80,80,'<rect width="80" height="80" rx="12" fill="#1a1a1a"/><text x="40" y="38" text-anchor="middle" dominant-baseline="central" fill="#C4A882" font-family="\'Georgia\',serif" font-size="34" font-weight="400">M</text><text x="40" y="60" text-anchor="middle" dominant-baseline="central" fill="#888" font-family="\'Helvetica Neue\',sans-serif" font-size="6" font-weight="500" letter-spacing="3">MANCERA</text>'),
    // Marc-Antoine Barrois — refined MAB
    'Marc-Antoine Barrois': svg(80,80,'<rect width="80" height="80" rx="12" fill="#2C2420"/><text x="40" y="36" text-anchor="middle" dominant-baseline="central" fill="#D4BC9A" font-family="\'Georgia\',serif" font-size="22" font-weight="400" letter-spacing="2">MAB</text><text x="40" y="56" text-anchor="middle" dominant-baseline="central" fill="#A89B91" font-family="\'Helvetica Neue\',sans-serif" font-size="5" font-weight="400" letter-spacing="1.5">BARROIS</text>'),
    // Narciso Rodriguez — lowercase serif wordmark
    'Narciso Rodriguez': svg(80,80,'<rect width="80" height="80" rx="12" fill="#fff" stroke="#eee" stroke-width="1"/><text x="40" y="33" text-anchor="middle" dominant-baseline="central" fill="#000" font-family="\'Georgia\',\'Times New Roman\',serif" font-size="11" font-weight="900" letter-spacing="0.8">narciso</text><text x="40" y="51" text-anchor="middle" dominant-baseline="central" fill="#000" font-family="\'Georgia\',\'Times New Roman\',serif" font-size="10" font-weight="900" letter-spacing="0.3">rodriguez</text>'),
    // Paco Rabanne — now rebranded as RABANNE
    'Paco Rabanne': svg(80,80,'<rect width="80" height="80" rx="12" fill="#000"/><text x="40" y="41" text-anchor="middle" dominant-baseline="central" fill="#fff" font-family="\'Helvetica Neue\',sans-serif" font-size="9" font-weight="700" letter-spacing="2.5">RABANNE</text>'),
    // Parfums de Marly — royal crest style
    'Parfums de Marly': svg(80,80,'<rect width="80" height="80" rx="12" fill="#1a2a1a"/><text x="40" y="34" text-anchor="middle" dominant-baseline="central" fill="#C4A882" font-family="\'Georgia\',serif" font-size="10" font-weight="400" letter-spacing="0.5">PARFUMS</text><text x="40" y="48" text-anchor="middle" dominant-baseline="central" fill="#D4BC9A" font-family="\'Georgia\',serif" font-size="10" font-weight="400" letter-spacing="0.5">DE MARLY</text><text x="40" y="64" text-anchor="middle" dominant-baseline="central" fill="#6a7a6a" font-family="serif" font-size="14">♞</text>'),
    // Rasasi — gold italic script on dark
    'Rasasi': svg(80,80,'<rect width="80" height="80" rx="12" fill="#1a1a1a"/><text x="40" y="43" text-anchor="middle" dominant-baseline="central" fill="#C8A84E" font-family="\'Georgia\',\'Palatino\',serif" font-size="19" font-weight="400" font-style="italic" letter-spacing="0.5">Rasasi</text>'),
    // Ralph Lauren
    'Ralph Lauren': svg(80,80,'<rect width="80" height="80" rx="12" fill="#1a2244"/><text x="40" y="36" text-anchor="middle" dominant-baseline="central" fill="#fff" font-family="\'Georgia\',serif" font-size="26" font-weight="700" letter-spacing="1">RL</text><text x="40" y="58" text-anchor="middle" dominant-baseline="central" fill="#8899bb" font-family="\'Helvetica Neue\',sans-serif" font-size="5.5" font-weight="400" letter-spacing="2">RALPH LAUREN</text>'),
    // Maison Margiela
    'Maison Margiela': roundRect('MM','#FAF8F5','#000','28','300',"'Helvetica Neue',sans-serif",'3')
  };
})();

// Brands whose favicon is generic/unusable — use styled SVG logo instead
const monogramBrands = new Set(Object.keys(brandSvgLogos));

// Monogram: first letter(s) of brand (fallback for unknown brands)
function brandMonogram(brand) {
  const words = brand.replace(/[^A-Za-z\s]/g,'').trim().split(/\s+/);
  if (words.length >= 2) return (words[0][0] + words[1][0]).toUpperCase();
  return brand.substring(0,2).toUpperCase();
}
function brandLogoUrl(brand) {
  // Check SVG logos first
  if (brandSvgLogos[brand]) return brandSvgLogos[brand];
  const domain = brandDomains[brand];
  return domain ? `https://www.google.com/s2/favicons?domain=${domain}&sz=128` : '';
}
// Fallback emoji icons for when logo fails to load
const brandIcons = {
  'Amouage':'🏛️','Azzaro':'⚜️','BDK Parfums Paris':'✦','Burberry':'🧣','Carolina Herrera':'👠',
  'Cartier':'💎','Chanel':'◆','Chopard':'🌿','Creed':'👑','Dior':'🌸','Emporio Armani':'🦅',
  'Ex Nihilo':'✧','Giorgio Armani':'🦅','Givenchy':'◇','Gucci':'🐝','Guerlain':'🍯',
  'Hermès':'🐎','Hugo Boss':'♦','Issey Miyake':'🌊','Jean Paul Gaultier':'⚓','Kenzo':'🌺',
  'Kilian Paris':'🥃','Maison Francis Kurkdjian':'🔮','Maison Margiela':'🔥','Mancera':'🌲',
  'Marc-Antoine Barrois':'☄️','Mugler':'⭐','Narciso Rodriguez':'🖤','Nicolaï Parfumeur-Créateur':'🗽',
  'Nishane':'🍋','Paco Rabanne':'🪙','Pantheon Roma':'🏛️','Parfums de Marly':'🐴',
  "Penhaligon's":'🎩','Prada':'◾','Ralph Lauren':'🏇','Rasasi':'🕌','Rochas':'🌹',
  'Rosendo Mateu':'🌿','Salvatore Ferragamo':'🧤','Serge Lutens':'🌳','Tom Ford':'🖤',
  'Valentino':'❤️','Xerjoff':'🏺','Yves Saint Laurent':'💄',"Viktor&Rolf":'💣',
  'French Avenue':'🇫🇷','Armaf':'🌙','Afnan':'✨'
};

const WA = '916378345040';
const sizes = [3,5,10,15,20];
const WA_SVG = '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>';

function icon(brand) { return brandIcons[brand]||'✦'; }
function fmt(n) { return n ? '₹'+n.toLocaleString('en-IN') : ''; }
function imgUrl(fid, customImg) { return customImg ? customImg : (fid ? `https://fimgs.net/mdimg/perfume/375x500.${fid}.jpg` : ''); }

// ─── CART SYSTEM ───
const CART_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>';
const CHECK_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>';
let cart = [];

function addToCart(productId, size) {
  const product = products.find(p => p.id === productId);
  if (!product) return;
  size = +size;
  const price = product.prices[size];
  // Check if same product + size already in cart
  const existing = cart.find(item => item.id === productId && item.size === size);
  if (existing) {
    showCartToast(product.title.split(' ').slice(0,3).join(' ') + ' (' + size + 'ml) is already in your cart');
    openCart();
    return;
  }
  cart.push({ id: productId, size: size, price: price });
  updateCartUI();
  showCartToast('Added to cart — ' + product.title.split(' ').slice(0,3).join(' ') + ' ' + size + 'ml');
  // Bounce badge animation
  const badge = document.getElementById('cartBadge');
  badge.classList.remove('bounce');
  void badge.offsetWidth;
  badge.classList.add('bounce');
  // Track add to cart event
  trackAddToCart(product, size, price);
}

function removeFromCart(index) {
  cart.splice(index, 1);
  updateCartUI();
}

function clearCart() {
  cart = [];
  updateCartUI();
}

function updateCartUI() {
  const badge = document.getElementById('cartBadge');
  const itemsEl = document.getElementById('cartItems');
  const emptyEl = document.getElementById('cartEmpty');
  const footerEl = document.getElementById('cartFooter');
  const totalEl = document.getElementById('cartTotal');
  const shippingEl = document.getElementById('cartShipping');
  const headerCount = document.getElementById('cartHeaderCount');

  // Badge
  badge.textContent = cart.length;
  badge.classList.toggle('show', cart.length > 0);
  headerCount.textContent = cart.length ? '(' + cart.length + ')' : '';
  // Sync product page badge
  const ppBadge = document.getElementById('ppCartBadge');
  if (ppBadge) { ppBadge.textContent = cart.length; ppBadge.classList.toggle('show', cart.length > 0); }

  // Items
  if (cart.length === 0) {
    itemsEl.innerHTML = '<div class="cart-empty" id="cartEmpty"><div class="cart-empty-icon">✦</div><h4>Your cart is empty</h4><p>Browse our collection and add your favourite fragrances</p><a href="#catalog" class="cart-empty-cta" onclick="closeCart()">Explore Collection</a></div>';
    footerEl.style.display = 'none';
    return;
  }

  footerEl.style.display = '';
  let total = 0;
  itemsEl.innerHTML = cart.map((item, idx) => {
    const p = products.find(x => x.id === item.id);
    if (!p) return '';
    total += item.price;
    const hasImg = !!p.fid || !!p.customImg;
    const imgSrc = hasImg ? imgUrl(p.fid, p.customImg) : '';
    return `<div class="cart-item">
      <div class="cart-item-num">${idx + 1}</div>
      <div class="cart-item-img">
        ${hasImg ? `<img src="${imgSrc}" alt="${p.title}" onerror="this.outerHTML='<span class=\\'cart-item-emoji\\'>${icon(p.brand)}</span>'">` : `<span class="cart-item-emoji">${icon(p.brand)}</span>`}
      </div>
      <div class="cart-item-details">
        <div class="cart-item-brand">${p.brand}</div>
        <div class="cart-item-name">${p.title}</div>
        <div class="cart-item-meta"><span class="cart-item-size">${item.size}ml</span></div>
      </div>
      <div class="cart-item-right">
        <div class="cart-item-price">${fmt(item.price)}</div>
        <button class="cart-item-remove" onclick="removeFromCart(${idx})">Remove</button>
      </div>
    </div>`;
  }).join('');

  // Summary
  const itemCountEl = document.getElementById('cartItemCount');
  if (itemCountEl) itemCountEl.textContent = cart.length + ' fragrance' + (cart.length > 1 ? 's' : '');
  totalEl.textContent = fmt(total);
  if (total >= 5000) {
    shippingEl.className = 'cart-shipping-note';
    shippingEl.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"/><path d="M12 5l7 7-7 7"/></svg><span>Free shipping on this order!</span>';
  } else {
    shippingEl.className = 'cart-shipping-note warn';
    shippingEl.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="3" width="15" height="13"/><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg><span>Add ' + fmt(5000 - total) + ' more for free shipping</span>';
  }

  // Update all Add to Cart buttons on visible cards
  document.querySelectorAll('.add-cart-btn[data-id]').forEach(btn => {
    const id = +btn.dataset.id, sz = +btn.dataset.size;
    const inCart = cart.some(c => c.id === id && c.size === sz);
    btn.classList.toggle('added', inCart);
    btn.innerHTML = inCart ? CHECK_SVG + ' <span>In Cart</span>' : CART_SVG + ' <span>Add to Cart</span>';
  });
}

function openCart() {
  document.getElementById('cartOverlay').classList.add('open');
  document.getElementById('cartDrawer').classList.add('open');
  document.body.style.overflow = 'hidden';
}

function closeCart() {
  document.getElementById('cartOverlay').classList.remove('open');
  document.getElementById('cartDrawer').classList.remove('open');
  if (!document.getElementById('productPage').classList.contains('open')) {
    document.body.style.overflow = '';
  }
}

function showCartToast(msg) {
  const toast = document.getElementById('cartToast');
  toast.textContent = msg;
  toast.classList.add('show');
  clearTimeout(toast._timer);
  toast._timer = setTimeout(() => toast.classList.remove('show'), 2500);
}

function sendCartToWhatsApp() {
  if (cart.length === 0) return;
  let total = 0;
  let lines = ['Hi Decant Diaries! I\'d like to order the following:\n'];
  cart.forEach((item, idx) => {
    const p = products.find(x => x.id === item.id);
    if (!p) return;
    total += item.price;
    lines.push((idx+1) + '. 🧴 ' + p.title + '\n   📏 Size: ' + item.size + 'ml\n   💰 Price: ' + fmt(item.price));
  });
  lines.push('\n📦 Total: ' + fmt(total) + ' (' + cart.length + ' item' + (cart.length>1?'s':'') + ')');
  if (total >= 5000) lines.push('🚚 Free shipping!');
  lines.push('\nPlease confirm availability and share payment details.');

  // Track checkout
  cart.forEach(item => {
    const p = products.find(x => x.id === item.id);
    if (p) trackInitiateCheckout(p, item.size, item.price);
  });

  const msg = encodeURIComponent(lines.join('\n'));
  window.open('https://wa.me/' + WA + '?text=' + msg, '_blank');
}

// ─── HELPERS: DETECT TOUCH ───
const isTouchDevice = () => 'ontouchstart' in window || navigator.maxTouchPoints > 0;
const overlay = document.getElementById('mobileOverlay');

function lockBody() { document.body.classList.add('menu-open'); }
function unlockBody() { document.body.classList.remove('menu-open'); }
function showOverlay() { overlay.classList.add('visible'); }
function hideOverlay() { overlay.classList.remove('visible'); }

// ─── CINEMATIC VIDEO SOUND TOGGLE ───
(function() {
  const vid = document.getElementById('cinemaVideo');
  const btn = document.getElementById('cinemaSound');
  if (vid && btn) {
    btn.addEventListener('click', function() {
      vid.muted = !vid.muted;
      btn.classList.toggle('unmuted', !vid.muted);
    });
  }
})();

// ─── BRAND MEGA MENU ───
const allBrands = (Array.isArray(window.__liquidBrands) && window.__liquidBrands.length)
  ? [...new Set(window.__liquidBrands.filter(Boolean))].sort((a,b)=>a.localeCompare(b))
  : [...new Set(products.map(p=>p.brand))].sort();
const brandCounts = {};
allBrands.forEach(b => { brandCounts[b] = (window.__liquidBrandCounts && window.__liquidBrandCounts[b]) || products.filter(p=>p.brand===b).length; });

function renderMegaBrands(filter='') {
  const grid = document.getElementById('megaBrandsGrid');
  const q = filter.toLowerCase();
  const filtered = q ? allBrands.filter(b=>b.toLowerCase().includes(q)) : allBrands;
  const __pc = window.__liquidProductCount || products.length;
  document.getElementById('megaBrandCount').textContent = `${filtered.length} houses · ${__pc} fragrances`;

  // Group by first letter
  const groups = {};
  filtered.forEach(b => {
    const letter = b.charAt(0).toUpperCase();
    if (!groups[letter]) groups[letter] = [];
    groups[letter].push(b);
  });

  const letters = Object.keys(groups).sort();
  // Distribute letter groups across 5 columns evenly
  const totalItems = filtered.length + letters.length; // brands + headers
  const targetPerCol = Math.ceil(totalItems / 5);
  const columns = [[], [], [], [], []];
  let col = 0, count = 0;
  letters.forEach(letter => {
    const groupSize = 1 + groups[letter].length; // header + brands
    if (count > 0 && count + groupSize > targetPerCol && col < 4) {
      col++; count = 0;
    }
    columns[col].push({ letter, brands: groups[letter] });
    count += groupSize;
  });

  grid.innerHTML = columns.map(colGroups => {
    if (!colGroups.length) return '';
    return `<div class="mega-az-column">${colGroups.map(g =>
      `<div class="mega-letter-group">
        <div class="mega-letter-heading">${g.letter}</div>
        ${g.brands.map(b => {
          const logoUrl = brandLogoUrl(b);
          const emojiIcon = brandIcons[b] || '';
          let logoHtml;
          if (logoUrl) {
            logoHtml = `<div class="mega-brand-logo"><img src="${logoUrl}" alt="" loading="lazy" onerror="this.outerHTML='<span class=\\'mega-logo-mono\\'>${brandMonogram(b)}</span>'"></div>`;
          } else if (emojiIcon) {
            logoHtml = `<div class="mega-brand-logo"><span class="mega-logo-emoji">${emojiIcon}</span></div>`;
          } else {
            logoHtml = `<div class="mega-brand-logo"><span class="mega-logo-mono">${brandMonogram(b)}</span></div>`;
          }
          return `<a class="mega-brand-link" href="#" onclick="filterByBrand('${b.replace(/'/g,"\\'")}');return false;">${logoHtml}${b}${brandCounts[b] ? ('<span class="mega-brand-ct">(' + brandCounts[b] + ')</span>') : ''}</a>`;
        }).join('')}
      </div>`
    ).join('')}</div>`;
  }).join('');
}
renderMegaBrands();

// Mega menu toggle
const megaMenu = document.getElementById('brandMegaMenu');
const brandsTrigger = document.getElementById('brandsTrigger');

function openMega() {
  megaMenu.classList.add('open');
  showOverlay(); lockBody();
}
function closeMega() {
  megaMenu.classList.remove('open');
  hideOverlay(); unlockBody();
}

// Desktop: hover to open/close
if (!isTouchDevice()) {
  brandsTrigger.addEventListener('mouseenter', openMega);
  brandsTrigger.addEventListener('mouseleave', () => {
    setTimeout(()=>{ if(!megaMenu.matches(':hover')) closeMega(); }, 120);
  });
  megaMenu.addEventListener('mouseenter', () => { megaMenu.classList.add('open'); });
  megaMenu.addEventListener('mouseleave', closeMega);
}

// Touch + click: tap to toggle (works on both mobile and desktop)
brandsTrigger.addEventListener('click', (e) => {
  e.preventDefault(); e.stopPropagation();
  if (megaMenu.classList.contains('open')) { closeMega(); }
  else {
    // On mobile, close the slide-out nav panel first so the mega menu is fully visible
    const navPanel = document.getElementById('navLinks');
    const toggle = document.getElementById('mobileToggle');
    if (navPanel && navPanel.classList.contains('open')) {
      toggle.classList.remove('active'); navPanel.classList.remove('open');
    }
    openMega();
  }
});

// Mega menu close button
document.getElementById('megaClose').addEventListener('click', closeMega);

// Overlay click closes everything
overlay.addEventListener('click', () => {
  closeMega(); closeMobileMenu();
});

let megaSearchDebounce;
document.getElementById('megaSearchInput').addEventListener('input', function() {
  const val = this.value;
  clearTimeout(megaSearchDebounce);
  megaSearchDebounce = setTimeout(() => renderMegaBrands(val), 80);
});

// Click on brand → scroll to catalog & filter
let currentBrandFilter = '';
function filterByBrand(brand) {
  closeMega();
  closeMobileMenu();
  closePP();
  currentBrandFilter = brand;
  const primary = window.__primaryCatalog || document.querySelector('section[data-catalog]');
  if (primary && primary.__apply) {
    primary.__apply(brand);
    const anchor = primary.id ? ('#' + primary.id) : '#catalog';
    setTimeout(() => { luxuryScroll(anchor, 800); }, 80);
  } else {
    window.location.href = '/pages/collection?q=' + encodeURIComponent(brand);
  }
}

// ─── PRODUCT CARDS ───
function createCard(product, defaultSize=3) {
  const card = document.createElement('div');
  card.className = 'product-card';
  card.dataset.brand = product.brand;
  card.dataset.title = product.title.toLowerCase();
  const retail = product.retail ? fmt(product.retail) : '';

  const hasImg = !!product.fid || !!product.customImg;
  card.innerHTML = `
    ${product.featured?'<div class="product-badge"><span>House Favourite</span></div>':''}
    <div class="product-img${hasImg?'':' no-img'}" onclick="openPP(${product.id})" role="button" tabindex="0" aria-label="View ${product.title}" onkeydown="if(event.key==='Enter')openPP(${product.id})">
      ${hasImg ? `<img src="${imgUrl(product.fid, product.customImg)}" alt="${product.title}" loading="lazy" onerror="this.parentElement.classList.add('no-img');var d=document.createElement('div');d.className='product-icon';d.textContent='${icon(product.brand)}';d.setAttribute('aria-label','${product.title.replace(/'/g,"\\'")}');this.replaceWith(d)">` : `<div class="product-icon" aria-label="${product.title}">${icon(product.brand)}</div>`}
    </div>
    <div class="product-info">
      <div class="product-brand">${product.brand}</div>
      <div class="product-name" style="cursor:pointer" onclick="openPP(${product.id})">${product.title}</div>
      <div class="product-type">${product.type}${retail?' · Retail '+retail:''}</div>
      <div class="size-options">
        ${sizes.map(s=>`<button class="size-btn${s===defaultSize?' active':''}" data-size="${s}">${s}ml</button>`).join('')}
      </div>
      <div class="product-price">${fmt(product.prices[defaultSize])} <span>/ ${defaultSize}ml</span></div>
      <div class="card-btn-row">
        <button class="order-btn" data-id="${product.id}" data-size="${defaultSize}" data-price="${product.prices[defaultSize]}">
          ${WA_SVG} <span>Order on WhatsApp</span>
        </button>
        <button class="add-cart-btn" data-id="${product.id}" data-size="${defaultSize}" data-price="${product.prices[defaultSize]}">
          ${CART_SVG} <span>Add to Cart</span>
        </button>
      </div>
    </div>`;

  card.querySelectorAll('.size-btn').forEach(btn=>{
    btn.addEventListener('click', e=>{
      e.stopPropagation();
      card.querySelectorAll('.size-btn').forEach(b=>b.classList.remove('active'));
      btn.classList.add('active');
      const s = +btn.dataset.size, p = product.prices[s];
      card.querySelector('.product-price').innerHTML = `${fmt(p)} <span>/ ${s}ml</span>`;
      const ob = card.querySelector('.order-btn');
      ob.dataset.size = s; ob.dataset.price = p;
      const ab = card.querySelector('.add-cart-btn');
      ab.dataset.size = s; ab.dataset.price = p;
      // Update add-to-cart state
      const inCart = cart.some(c => c.id === product.id && c.size === s);
      ab.classList.toggle('added', inCart);
      ab.innerHTML = inCart ? CHECK_SVG + ' <span>In Cart</span>' : CART_SVG + ' <span>Add to Cart</span>';
    });
  });

  card.querySelector('.order-btn').addEventListener('click', function(e){
    e.stopPropagation();
    const s = this.dataset.size, p = this.dataset.price;
    const msg = encodeURIComponent('Hi Decant Diaries! I\u0027d like to order:\n\n\uD83E\uDDF4 ' + product.title + '\n\uD83D\uDCCF Size: ' + s + 'ml\n\uD83D\uDCB0 Price: \u20B9' + p + '\n\nPlease confirm availability.');
    window.open(`https://wa.me/${WA}?text=${msg}`,'_blank');
  });

  card.querySelector('.add-cart-btn').addEventListener('click', function(e){
    e.stopPropagation();
    addToCart(product.id, +this.dataset.size);
  });

  return card;
}

// ─── PRODUCT DETAIL PAGE ───
let ppCurrentProduct = null;
let ppSelectedSize = 3;

function openPP(id) {
  const p = products.find(x=>x.id===id);
  if(!p) return;
  ppCurrentProduct = p;
  ppSelectedSize = 3;

  // Set product page image
  const ppImg = document.querySelector('.pp-image');
  if (p.fid || p.customImg) {
    ppImg.classList.remove('no-img');
    ppImg.innerHTML = `<img src="${imgUrl(p.fid, p.customImg)}" alt="${p.title}" onerror="this.parentElement.classList.add('no-img');var d=document.createElement('div');d.className='pp-image-icon';d.textContent='${icon(p.brand)}';d.setAttribute('aria-label','${p.title.replace(/'/g,"\\'")}');this.replaceWith(d)">`;
  } else {
    ppImg.classList.add('no-img');
    ppImg.innerHTML = `<div class="pp-image-icon" aria-label="${p.title}">${icon(p.brand)}</div>`;
  }
  document.getElementById('ppBreadcrumb').textContent = p.title;
  document.getElementById('ppBrand').textContent = p.brand;
  document.getElementById('ppTitle').textContent = p.title;
  document.getElementById('ppType').textContent = p.type;
  document.getElementById('ppRetail').innerHTML = p.retail ? `Full bottle retail: <strong>${fmt(p.retail)}</strong>` : '';

  // Size buttons
  const sizesEl = document.getElementById('ppSizes');
  sizesEl.innerHTML = sizes.map(s=>`
    <button class="pp-size-btn${s===3?' active':''}" data-size="${s}">
      <span class="pp-size-ml">${s}ml</span>
      <span class="pp-size-price">${fmt(p.prices[s])}</span>
    </button>
  `).join('');

  sizesEl.querySelectorAll('.pp-size-btn').forEach(btn=>{
    btn.addEventListener('click', ()=>{
      sizesEl.querySelectorAll('.pp-size-btn').forEach(b=>b.classList.remove('active'));
      btn.classList.add('active');
      ppSelectedSize = +btn.dataset.size;
      updatePPPrice();
    });
  });

  updatePPPrice();

  // "Why Choose a Decant?" section — dynamic based on product
  const whyList = document.getElementById('ppWhyList');
  const retailStr = p.retail ? fmt(p.retail) : '₹5,000+';
  whyList.innerHTML = `
    <li><span class="pp-check">✓</span>Experience a ${retailStr} fragrance for just ${fmt(p.prices[3])}</li>
    <li><span class="pp-check">✓</span>5 sizes available — from a weekend trial to a full month's wear</li>
    <li><span class="pp-check">✓</span>Hand-decanted from sealed, authentic retail bottles</li>
    <li><span class="pp-check">✓</span>Free shipping on orders above ₹5,000</li>
  `;

  // Track product view
  trackViewContent(p);

  // Order button
  document.getElementById('ppOrderBtn').onclick = function() {
    const price = p.prices[ppSelectedSize];
    trackAddToCart(p, ppSelectedSize, price);
    trackInitiateCheckout(p, ppSelectedSize, price);
    const msg = encodeURIComponent('Hi Decant Diaries! I\u0027d like to order:\n\n\uD83E\uDDF4 ' + p.title + '\n\uD83C\uDFF7\uFE0F ' + p.brand + '\n\uD83D\uDCCF Size: ' + ppSelectedSize + 'ml\n\uD83D\uDCB0 Price: ' + fmt(price) + '\n\nPlease confirm availability.');
    window.open(`https://wa.me/${WA}?text=${msg}`,'_blank');
  };

  // Add to Cart button on product page
  const ppCartBtn = document.getElementById('ppAddCartBtn');
  function updatePPCartBtnState() {
    const inCart = cart.some(c => c.id === p.id && c.size === ppSelectedSize);
    ppCartBtn.classList.toggle('added', inCart);
    ppCartBtn.innerHTML = inCart
      ? '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg> In Cart'
      : '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg> Add to Cart';
  }
  updatePPCartBtnState();
  ppCartBtn.onclick = function() {
    addToCart(p.id, ppSelectedSize);
    updatePPCartBtnState();
  };
  // Store ref for updatePPPrice to call
  window._updatePPCartBtnState = updatePPCartBtnState;

  const pp = document.getElementById('productPage');
  pp.classList.add('open');
  pp.scrollTop = 0;
  document.body.style.overflow = 'hidden';
  // Push state so back button closes product page
  history.pushState({product: id}, '', '#product-' + id);
}

function updatePPPrice() {
  const p = ppCurrentProduct;
  const price = p.prices[ppSelectedSize];
  document.getElementById('ppPrice').innerHTML = `${fmt(price)} <span>/ ${ppSelectedSize}ml</span>`;

  // Value bar — shows how much of the full bottle value you're getting
  const valueBar = document.getElementById('ppValueBar');
  if (p.retail) {
    const perMlRetail = p.retail / 100; // typical full bottle is ~100ml
    const perMlDecant = price / ppSelectedSize;
    const savingsPercent = Math.round((1 - perMlDecant / perMlRetail) * 100);
    const fillPercent = Math.min(Math.max(savingsPercent, 10), 95);
    valueBar.innerHTML = `
      <div class="pp-value-bar-label">
        <span>Value vs full bottle</span>
        <strong>${savingsPercent > 0 ? savingsPercent + '% more affordable per ml' : 'Great value'}</strong>
      </div>
      <div class="pp-value-track"><div class="pp-value-fill" style="width:${fillPercent}%"></div></div>
    `;
  } else {
    valueBar.innerHTML = '';
  }

  // Savings text
  const savingsEl = document.getElementById('ppSavings');
  if (p.retail) {
    savingsEl.textContent = `Experience this ${fmt(p.retail)} fragrance for just ${fmt(price)}`;
  } else {
    savingsEl.textContent = '';
  }

  // Free shipping badge
  const freeShip = document.getElementById('ppFreeShipping');
  if (price >= 5000) {
    freeShip.className = 'pp-free-shipping';
    freeShip.innerHTML = `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"/><path d="M12 5l7 7-7 7"/></svg> <span>This order qualifies for <strong>free shipping!</strong></span>`;
  } else {
    const remaining = 5000 - price;
    freeShip.className = 'pp-free-shipping inactive';
    freeShip.innerHTML = `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="3" width="15" height="13"/><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg> <span>Add ${fmt(remaining)} more for <strong>free shipping</strong></span>`;
  }

  // Update cart button state when size changes
  if (window._updatePPCartBtnState) window._updatePPCartBtnState();
}

function closePP() {
  document.getElementById('productPage').classList.remove('open');
  document.body.style.overflow = '';
  // Restore hash for back button support
  if (window.location.hash.startsWith('#product-')) {
    history.replaceState(null, '', window.location.pathname);
  }
}

// Handle browser back button for product pages
window.addEventListener('popstate', () => {
  if (!window.location.hash.startsWith('#product-')) closePP();
});

// Close on Escape — unified handler for all overlays
document.addEventListener('keydown', e => {
  if (e.key === 'Escape') {
    closePolicy(); closePP(); closeMega(); closeMobileMenu(); closeCart();
  }
});

// ─── SERVER-RENDERED (LIQUID) PRODUCT CARDS ───
function ensureProductFromCard(card){
  const id = +card.dataset.productId;
  let p = products.find(x=>x.id===id);
  if (!p){
    const prices={}, variants=[];
    card.querySelectorAll('.size-btn').forEach(b=>{ const s=+b.dataset.size; prices[s]=+b.dataset.price; variants.push({id:(+b.dataset.variantId||0),size:s,price:+b.dataset.price}); });
    const nameEl = card.querySelector('.product-name');
    p = { id:id, handle:card.dataset.handle, title:(nameEl?nameEl.textContent.trim():''), brand:card.dataset.brand||'', type:card.dataset.type||'', prices:prices, retail:0, featured:(card.dataset.featured==='true'), fid:(+card.dataset.fid||0), variants:variants };
    products.push(p);
  }
  return p;
}
function wireLiquidCard(card){
  const id = +card.dataset.productId;
  const sizeBtns = card.querySelectorAll('.size-btn');
  const priceEl = card.querySelector('.product-price');
  const orderBtn = card.querySelector('.order-btn');
  const addBtn = card.querySelector('.add-cart-btn');
  const nameEl = card.querySelector('.product-name');
  const titleText = (nameEl ? nameEl.textContent : '').trim();
  function refreshAdd(s){ if(!addBtn) return; const inCart = cart.some(c=>c.id===id && c.size===+s); addBtn.classList.toggle('added', inCart); addBtn.innerHTML = inCart ? (CHECK_SVG+' <span>In Cart</span>') : (CART_SVG+' <span>Add to Cart</span>'); }
  sizeBtns.forEach(btn=>btn.addEventListener('click', function(e){
    e.stopPropagation(); e.preventDefault();
    sizeBtns.forEach(b=>b.classList.remove('active')); btn.classList.add('active');
    const s = btn.dataset.size, p = btn.dataset.price;
    if (priceEl) priceEl.innerHTML = fmt(+p) + ' <span>/ ' + s + 'ml</span>';
    if (orderBtn){ orderBtn.dataset.size = s; orderBtn.dataset.price = p; }
    if (addBtn){ addBtn.dataset.size = s; addBtn.dataset.price = p; refreshAdd(s); }
  }));
  if (orderBtn) orderBtn.addEventListener('click', function(e){
    e.stopPropagation(); e.preventDefault();
    const s = orderBtn.dataset.size, p = orderBtn.dataset.price;
    const msg = encodeURIComponent('Hi Decant Diaries! I\u0027d like to order:\n\n\uD83E\uDDF4 ' + titleText + '\n\uD83D\uDCCF Size: ' + s + 'ml\n\uD83D\uDCB0 Price: \u20B9' + p + '\n\nPlease confirm availability.');
    window.open('https://wa.me/' + WA + '?text=' + msg, '_blank');
  });
  if (addBtn) addBtn.addEventListener('click', function(e){
    e.stopPropagation(); e.preventDefault();
    ensureProductFromCard(card);
    addToCart(id, addBtn.dataset.size);
  });
}

// ─── FEATURED ───
const featuredGrid = document.getElementById('featuredGrid');
if (featuredGrid) {
  products.filter(p=>p.featured).forEach(p=>featuredGrid.appendChild(createCard(p)));
}

// ─── CATALOG (multi-instance, server-rendered Liquid cards) ───
let currentSearch = '';
let currentSort = 'az';
function initCatalogSection(root){
  const grid = root.querySelector('.catalog-grid');
  if (!grid) return;
  const searchInput = root.querySelector('.catalog-search');
  const sortSelect = root.querySelector('.catalog-sort, .sort-select');
  const countEl = root.querySelector('.catalog-count');
  const total = grid.getAttribute('data-total');
  let search = '', sort = 'az';
  if (grid.querySelector('.product-card')) {
    grid.querySelectorAll('.product-card').forEach(wireLiquidCard);
    const cards = () => Array.from(grid.querySelectorAll('.product-card'));
    function apply(){
      const q = search.trim().toLowerCase();
      let shown = 0;
      cards().forEach(c=>{ const hay=(c.dataset.title||'')+' '+(c.dataset.brand||'').toLowerCase()+' '+(c.dataset.type||'').toLowerCase(); const ok=!q||hay.indexOf(q)!==-1; c.style.display=ok?'':'none'; if(ok)shown++; });
      const cmp = { az:(a,b)=>(a.dataset.title||'').localeCompare(b.dataset.title||''), za:(a,b)=>(b.dataset.title||'').localeCompare(a.dataset.title||''), brand:(a,b)=>((a.dataset.brand||'').localeCompare(b.dataset.brand||''))||((a.dataset.title||'').localeCompare(b.dataset.title||'')) }[sort];
      if (cmp) cards().sort(cmp).forEach(c=>grid.appendChild(c));
      if (countEl){ const pc=cards().length; countEl.textContent = q?('Showing '+shown+' of '+pc+' on this page'):('Showing '+pc+(total?(' of '+total):'')+' fragrances'); }
    }
    root.__apply = function(q){ if(typeof q==='string'){ search=q; if(searchInput) searchInput.value=q; } apply(); };
    if (searchInput){ let d; searchInput.addEventListener('input', function(){ search=this.value; clearTimeout(d); d=setTimeout(apply,120); }); }
    if (sortSelect){ sortSelect.addEventListener('change', function(){ sort=this.value; apply(); }); }
    apply();
  } else {
    function render(){
      grid.innerHTML='';
      let f = products;
      if(search){ const q=search.toLowerCase(); f=f.filter(p=>p.title.toLowerCase().includes(q)||p.brand.toLowerCase().includes(q)||p.type.toLowerCase().includes(q)); }
      switch(sort){ case 'az': f.sort((a,b)=>a.title.localeCompare(b.title)); break; case 'za': f.sort((a,b)=>b.title.localeCompare(a.title)); break; case 'brand': f.sort((a,b)=>a.brand.localeCompare(b.brand)||a.title.localeCompare(b.title)); break; }
      if(countEl) countEl.textContent='Showing '+f.length+' of '+products.length+' fragrances';
      if(!f.length){ grid.innerHTML='<div class="no-results"><h3>No fragrances found</h3><p>Try a different search term.</p></div>'; return; }
      f.forEach(p=>grid.appendChild(createCard(p)));
    }
    root.__apply = function(q){ if(typeof q==='string'){ search=q; if(searchInput) searchInput.value=q; } render(); };
    if (searchInput){ let d; searchInput.addEventListener('input', function(){ search=this.value; clearTimeout(d); d=setTimeout(render,120); }); }
    if (sortSelect){ sortSelect.addEventListener('change', function(){ sort=this.value; render(); }); }
    render();
  }
}
(function initCatalogs(){
  const sections = document.querySelectorAll('section[data-catalog]');
  if (!sections.length) return;
  sections.forEach(initCatalogSection);
  const primary = document.querySelector('section[data-catalog-primary]') || sections[0];
  window.__primaryCatalog = primary;
  window.__applyCatalog = function(q){ if (primary && primary.__apply) primary.__apply(q); };
  try { const qp = new URLSearchParams(window.location.search).get('q'); if (qp && primary && primary.__apply) primary.__apply(qp); } catch(e){}
})();

// ─── SCROLL / NAV ───
const nav = document.getElementById('nav');
const btt = document.getElementById('backToTop');
const announcementBar = document.getElementById('announcementBar');

// Dynamically position nav below announcement bar (handles text wrapping on mobile)
function adjustNavTop() {
  if (!announcementBar || !nav) return;
  const abHeight = announcementBar.classList.contains('hidden') ? 0 : announcementBar.offsetHeight;
  nav.style.top = abHeight + 'px';
}
adjustNavTop();
window.addEventListener('resize', adjustNavTop);

window.addEventListener('scroll', ()=>{
  const scrolled = window.scrollY > 50;
  nav.classList.toggle('scrolled', scrolled);
  btt.classList.toggle('visible', window.scrollY>600);
  // Hide announcement bar on scroll
  if (announcementBar) {
    announcementBar.classList.toggle('hidden', scrolled);
    adjustNavTop();
  }
}, { passive: true });
btt.addEventListener('click', ()=>luxuryScroll('#hero', 500));

// Mobile menu
const mt = document.getElementById('mobileToggle');
const nl = document.getElementById('navLinks');

function openMobileMenu() {
  mt.classList.add('active'); nl.classList.add('open');
  showOverlay(); lockBody();
}
function closeMobileMenu() {
  mt.classList.remove('active'); nl.classList.remove('open');
  if (!megaMenu.classList.contains('open')) { hideOverlay(); unlockBody(); }
}

mt.addEventListener('click', () => {
  if (nl.classList.contains('open')) closeMobileMenu();
  else openMobileMenu();
});
nl.querySelectorAll('.nav-link').forEach(a => {
  // Only close menu for actual navigation links (not the brands trigger)
  if (!a.closest('.nav-brands-trigger')) {
    a.addEventListener('click', closeMobileMenu);
  }
});
// Close menu when CTA is clicked
const ctaLink = nl.querySelector('.nav-cta');
if (ctaLink) ctaLink.addEventListener('click', closeMobileMenu);

// Scroll reveal (+ stagger support)
const observer = new IntersectionObserver(entries=>{
  entries.forEach(e=>{ if(e.isIntersecting) e.target.classList.add('visible'); });
},{threshold:0.1});
document.querySelectorAll('.reveal').forEach(el=>observer.observe(el));

// ─── BRAND MARQUEE ───
(function() {
  const track = document.getElementById('marqueeTrack');
  if (!track) return;
  let items = '';
  // Duplicate the list for seamless loop
  for (let i = 0; i < 2; i++) {
    allBrands.forEach(b => {
      const logoSrc = brandLogoUrl(b);
      const mono = brandMonogram(b);
      const logoHTML = logoSrc
        ? `<img src="${logoSrc}" alt="${b}" loading="lazy" onerror="this.replaceWith(Object.assign(document.createElement('span'),{className:'brand-mono',textContent:'${mono}'}))">`
        : `<span class="brand-mono">${mono}</span>`;
      items += `<div class="marquee-item" onclick="filterByBrand('${b.replace(/'/g,"\\'")}')">
        <div class="marquee-logo${logoSrc ? '' : ' mono-bg'}">${logoHTML}</div>
        <span class="marquee-name">${b}</span>
        <span class="marquee-dot"></span>
      </div>`;
    });
  }
  track.innerHTML = items;
})();

// ─── HERO COUNT-UP ANIMATION ───
(function() {
  const nums = document.querySelectorAll('.hero-stat-num[data-count]');
  let counted = false;
  function countUp() {
    if (counted) return;
    counted = true;
    nums.forEach(el => {
      const target = parseInt(el.dataset.count);
      const suffix = target >= 10 ? '+' : '';
      const duration = 1800;
      const steps = 40;
      const increment = target / steps;
      let current = 0;
      let step = 0;
      const timer = setInterval(() => {
        step++;
        current = Math.min(Math.round(increment * step), target);
        el.textContent = current + suffix;
        if (step >= steps) clearInterval(timer);
      }, duration / steps);
    });
  }
  // Trigger when hero stats become visible
  const statsObs = new IntersectionObserver(entries => {
    entries.forEach(e => { if (e.isIntersecting) countUp(); });
  }, { threshold: 0.5 });
  const statsEl = document.querySelector('.hero-stats');
  if (statsEl) statsObs.observe(statsEl);
})();

// ─── HERO FLOATING PARTICLES ───
(function() {
  const container = document.getElementById('heroParticles');
  if (!container) return;
  const MAX_PARTICLES = 20;
  let particleInterval;
  function spawnParticle() {
    if (container.children.length >= MAX_PARTICLES) return;
    const p = document.createElement('div');
    p.className = 'particle';
    const left = Math.random() * 100;
    const size = 2 + Math.random() * 4;
    const dur = 6 + Math.random() * 8;
    const delay = Math.random() * 4;
    p.style.cssText = `left:${left}%;bottom:-10px;width:${size}px;height:${size}px;animation-duration:${dur}s;animation-delay:${delay}s;`;
    container.appendChild(p);
    setTimeout(() => p.remove(), (dur + delay) * 1000);
  }
  for (let i = 0; i < 12; i++) spawnParticle();
  particleInterval = setInterval(spawnParticle, 2000);
  const heroObs = new IntersectionObserver(entries => {
    entries.forEach(e => {
      if (!e.isIntersecting) { clearInterval(particleInterval); particleInterval = null; }
      else if (!particleInterval) { particleInterval = setInterval(spawnParticle, 2000); }
    });
  }, { threshold: 0 });
  const heroEl = document.getElementById('hero');
  if (heroEl) heroObs.observe(heroEl);
})();

// ─── SMOOTH SCROLL ───
// easeOutCubic — starts fast, decelerates gently (no initial lag)
function luxuryScroll(target, duration) {
  duration = duration || 500;
  const targetEl = typeof target === 'string' ? document.querySelector(target) : target;
  if (!targetEl) return;
  const navHeight = document.getElementById('nav').offsetHeight;
  const targetY = targetEl.getBoundingClientRect().top + window.scrollY - navHeight - 20;
  const startY = window.scrollY;
  const diff = targetY - startY;
  if (Math.abs(diff) < 5) return; // already there
  let startTime = null;

  function ease(t) { return 1 - Math.pow(1 - t, 3); }

  function step(timestamp) {
    if (!startTime) startTime = timestamp;
    const progress = Math.min((timestamp - startTime) / duration, 1);
    window.scrollTo(0, startY + diff * ease(progress));
    if (progress < 1) requestAnimationFrame(step);
  }
  requestAnimationFrame(step);
}

// Intercept all anchor links on the page
document.addEventListener('click', function(e) {
  const link = e.target.closest('a[href^="#"]');
  if (!link) return;
  const hash = link.getAttribute('href');
  if (!hash || hash === '#') return;
  const targetEl = document.querySelector(hash);
  if (!targetEl) return;
  e.preventDefault();
  // Calculate distance to pick duration — farther = longer journey
  const navH = document.getElementById('nav').offsetHeight;
  const dist = Math.abs(targetEl.getBoundingClientRect().top);
  const duration = Math.min(700, Math.max(350, dist * 0.25));
  luxuryScroll(targetEl, duration);
  // Update URL hash without jumping
  history.pushState(null, '', hash);
});

// Also fix the breadcrumb scrollIntoView calls
window.luxuryScrollTo = function(selector) {
  luxuryScroll(selector, 500);
};

// Nav shrink handled in main scroll listener above

// ─── POLICY PAGES (Privacy, Terms, Refund, Shipping) ───
const ADDR = 'B1003 Mahima Florenza, Mansarovar, Jaipur, Rajasthan 302020, India';
const CONTACT_BLOCK = '<p><strong>Decant Diaries</strong><br>Address: ' + ADDR + '<br>Email: <a href="mailto:support@decantdiaries.in">support@decantdiaries.in</a><br>Phone/WhatsApp: <a href="tel:+916378345040">+91 63783 45040</a></p>';
const policies = {
  privacy: {
    title: 'Privacy Policy',
    content: `
      <p><strong>Last Updated:</strong> 13 January 2026</p>
      <p>Decant Diaries operates this store and website, including all related information, content, features, tools, products and services, in order to provide you, the customer, with a curated shopping experience (the "Services"). This Privacy Policy describes how we collect, use, and disclose your personal information when you visit, use, or make a purchase or other transaction using the Services or otherwise communicate with us.</p>
      <p>Please read this Privacy Policy carefully. By using and accessing any of the Services, you acknowledge that you have read this Privacy Policy and understand the collection, use, and disclosure of your information as described herein.</p>

      <h3>Personal Information We Collect or Process</h3>
      <p>When we use the term "personal information," we are referring to information that identifies or can reasonably be linked to you or another person. We may collect or process the following categories of personal information:</p>
      <ul>
        <li><strong>Contact details</strong> including your name, address, billing address, shipping address, phone number, and email address.</li>
        <li><strong>Financial information</strong> including payment card information, transaction details, form of payment, payment confirmation and other payment details.</li>
        <li><strong>Account information</strong> including your username, password, preferences and settings.</li>
        <li><strong>Transaction information</strong> including the items you view, put in your cart, add to your wishlist, or purchase, return, exchange or cancel and your past transactions.</li>
        <li><strong>Communications with us</strong> including the information you include in communications with us, for example, when sending a customer support inquiry.</li>
        <li><strong>Device information</strong> including information about your device, browser, or network connection, your IP address, and other unique identifiers.</li>
        <li><strong>Usage information</strong> including information regarding your interaction with the Services, including how and when you interact with or navigate the Services.</li>
      </ul>

      <h3>Personal Information Sources</h3>
      <p>We may collect personal information from the following sources:</p>
      <ul>
        <li><strong>Directly from you</strong> including when you visit or use the Services, communicate with us, or otherwise provide us with your personal information.</li>
        <li><strong>Automatically through the Services</strong> including from your device when you use our services or visit our website, and through the use of cookies and similar technologies.</li>
        <li><strong>From our service providers</strong> including when we engage them to enable certain technology and when they collect or process your personal information on our behalf.</li>
        <li><strong>From our partners or other third parties.</strong></li>
      </ul>

      <h3>How We Use Your Personal Information</h3>
      <ul>
        <li><strong>Provide, Tailor, and Improve the Services.</strong> We use your personal information to provide you with the Services, to process your payments, to fulfil your orders, to remember your preferences, to send notifications related to your account, to arrange for shipping, to facilitate returns and exchanges, and to create a customised shopping experience for you.</li>
        <li><strong>Marketing and Advertising.</strong> We use your personal information for marketing and promotional purposes, such as to send marketing, advertising and promotional communications by email, text message or postal mail, and to show you online advertisements for products or services, including based on items you previously have purchased or added to your cart.</li>
        <li><strong>Security and Fraud Prevention.</strong> We use your personal information to authenticate your account, to provide a secure payment and shopping experience, and to detect, investigate or take action regarding possible fraudulent, illegal, or malicious activity.</li>
        <li><strong>Communicating with You.</strong> We use your personal information to provide you with customer support and to maintain our business relationship with you.</li>
        <li><strong>Legal Reasons.</strong> We use your personal information to comply with applicable law or respond to valid legal process.</li>
      </ul>

      <h3>Cookies &amp; Tracking Technologies (Google Ads &amp; Meta Ads Disclosure)</h3>
      <p>We use the following cookies and tracking technologies on our website:</p>
      <ul>
        <li><strong>Google Analytics (GA4):</strong> Measures website traffic, user behaviour, and engagement. Collects anonymised data about pages visited, session duration, and demographics.</li>
        <li><strong>Google Ads (gtag.js):</strong> Tracks conversions from Google Ads campaigns and enables remarketing to show you relevant ads across Google's network based on your visit to our site.</li>
        <li><strong>Meta Pixel (Facebook/Instagram):</strong> Tracks conversions from Facebook and Instagram ad campaigns. Enables custom audiences for remarketing and lookalike targeting. Collects data about page views, product views, and checkout initiation.</li>
        <li><strong>Essential Cookies:</strong> Remember your cookie consent preference and ensure core website functionality.</li>
      </ul>
      <p>You can manage cookie preferences via your browser settings or by clicking "Decline" on our cookie consent banner. Declining non-essential cookies will disable Google Ads remarketing and Meta Pixel tracking, but will not affect core website functionality. You may also opt out of personalised advertising by visiting <a href="https://adssettings.google.com" target="_blank">Google Ad Settings</a> or <a href="https://www.facebook.com/adpreferences" target="_blank">Facebook Ad Preferences</a>.</p>

      <h3>How We Disclose Personal Information</h3>
      <p>In certain circumstances, we may disclose your personal information to third parties for legitimate purposes, including:</p>
      <ul>
        <li>With vendors and third parties who perform services on our behalf (e.g. payment processing, data analytics, customer support, cloud storage, fulfilment and shipping).</li>
        <li>With business and marketing partners (including Google and Meta/Facebook) to provide marketing services and serve relevant advertisements to you. These partners will use your information in accordance with their own privacy notices.</li>
        <li>When you direct, request or otherwise consent to our disclosure of certain information to third parties.</li>
        <li>With our affiliates or otherwise within our corporate group.</li>
        <li>In connection with a business transaction such as a merger or bankruptcy, to comply with any applicable legal obligations, and to protect or defend the Services, our rights, and the rights of our users or others.</li>
      </ul>

      <h3>Third Party Websites and Links</h3>
      <p>The Services may provide links to websites or other online platforms operated by third parties (including WhatsApp, Instagram, YouTube). If you follow links to sites not affiliated or controlled by us, you should review their privacy and security policies. We are not responsible for the privacy or security of such sites.</p>

      <h3>Children's Data</h3>
      <p>The Services are not intended to be used by children, and we do not knowingly collect any personal information about children under the age of 18. If you are the parent or guardian of a child who has provided us with their personal information, you may contact us to request that it be deleted.</p>

      <h3>Security and Retention of Your Information</h3>
      <p>Please be aware that no security measures are perfect or impenetrable. How long we retain your personal information depends on different factors, such as whether we need the information to maintain your account, to provide you with Services, comply with legal obligations, resolve disputes or enforce other applicable contracts and policies.</p>

      <h3>Your Rights and Choices</h3>
      <p>Depending on where you live, you may have some or all of the following rights:</p>
      <ul>
        <li><strong>Right to Access / Know.</strong> You may request access to personal information that we hold about you.</li>
        <li><strong>Right to Delete.</strong> You may request that we delete personal information we maintain about you.</li>
        <li><strong>Right to Correct.</strong> You may request that we correct inaccurate personal information.</li>
        <li><strong>Right of Portability.</strong> You may request a copy of the personal information we hold about you.</li>
        <li><strong>Managing Communication Preferences.</strong> You may opt out of promotional emails at any time.</li>
      </ul>
      <p>You may exercise any of these rights by contacting us using the contact details provided below.</p>

      <h3>Changes to This Privacy Policy</h3>
      <p>We may update this Privacy Policy from time to time, including to reflect changes to our practices or for other operational, legal, or regulatory reasons. We will post the revised Privacy Policy on this website and update the "Last Updated" date.</p>

      <h3>Contact</h3>
      <p>Should you have any questions about our privacy practices or this Privacy Policy, or if you would like to exercise any of the rights available to you, please contact us at:</p>
      ` + CONTACT_BLOCK + `
    `
  },
  terms: {
    title: 'Terms & Conditions',
    content: `
      <p><strong>Last Updated:</strong> 22 March 2026</p>
      <p>Welcome to Decant Diaries. By accessing and using our website <strong>decantdiaries.in</strong> or placing an order, you agree to be bound by these Terms &amp; Conditions. If you do not agree to these terms, please do not use our website or services.</p>

      <h3>1. About Decant Diaries</h3>
      <p>Decant Diaries is a fragrance decanting business operated from ` + ADDR + `. We sell fragrance decants — smaller portions of authentic, full-size perfumes — hand-decanted from sealed retail bottles into premium glass atomizers. We are not affiliated with, endorsed by, or authorised resellers of any fragrance house or brand. All brand names, trademarks, and product images are the property of their respective owners and are used solely for product identification purposes.</p>

      <h3>2. Eligibility</h3>
      <p>You must be at least 18 years of age to use our website and place orders. By using the Services, you represent and warrant that you are at least 18 years old and have the legal capacity to enter into a binding agreement.</p>

      <h3>3. Products &amp; Descriptions</h3>
      <p>We make every effort to display product information (names, descriptions, types, images) as accurately as possible. However, product images may be sourced from third-party databases (e.g. Fragrantica) and may vary slightly from the actual product. Fragrance is inherently subjective, and individual experiences with any scent may vary. Decant sizes available are 3ml, 5ml, 10ml, 15ml, and 20ml.</p>

      <h3>4. Ordering &amp; Payment</h3>
      <p>Orders are placed via WhatsApp at <a href="https://wa.me/916378345040">+91 63783 45040</a>. Prices listed on the website are in Indian Rupees (INR) and are subject to change without prior notice. An order is confirmed only after payment is received and acknowledged by our team. We accept payments via UPI, bank transfer, and other digital payment methods communicated during the ordering process. Full payment is required before order dispatch. Cash on Delivery (COD) is not available.</p>

      <h3>5. Shipping &amp; Delivery</h3>
      <p>We ship across India. A flat shipping charge of ₹250 applies to orders below ₹5,000. Orders above ₹5,000 qualify for free shipping. Standard delivery takes 4–5 business days. For full details, please refer to our <a href="#" onclick="openPolicy('shipping');return false;">Shipping Policy</a>.</p>

      <h3>6. Returns, Refunds &amp; Exchanges</h3>
      <p>Returns are accepted within 7 days of delivery subject to conditions. Due to the nature of fragrance products, used or partially used items are not eligible for return. For full details, please refer to our <a href="#" onclick="openPolicy('refund');return false;">Return &amp; Refund Policy</a>.</p>

      <h3>7. Intellectual Property</h3>
      <p>All content on this website — including text, design, graphics, layout, logos, and code — is the property of Decant Diaries unless otherwise noted and is protected by applicable intellectual property laws. You may not reproduce, distribute, modify, or create derivative works from any content on this website without our prior written consent.</p>

      <h3>8. Limitation of Liability</h3>
      <p>Decant Diaries shall not be liable for any indirect, incidental, special, or consequential damages arising from the use of our products or website. Our maximum aggregate liability for any claim is limited to the amount you paid for the specific order giving rise to the claim. We do not guarantee that the website will be available at all times, uninterrupted, or error-free.</p>

      <h3>9. User Conduct</h3>
      <p>You agree not to: misuse the website or attempt to access it through unauthorised means; use automated tools to scrape or collect data; interfere with the security or integrity of the website; impersonate any person or entity; or use the products for any unlawful purpose.</p>

      <h3>10. Privacy</h3>
      <p>Your use of the Services is also governed by our <a href="#" onclick="openPolicy('privacy');return false;">Privacy Policy</a>, which describes how we collect, use, and share your personal information, including through cookies, Google Analytics, Google Ads, and the Meta Pixel.</p>

      <h3>11. Indemnification</h3>
      <p>You agree to indemnify and hold harmless Decant Diaries, its officers, directors, and employees from any claims, liabilities, damages, losses, or expenses arising out of your use of the Services or violation of these Terms.</p>

      <h3>12. Modifications</h3>
      <p>We reserve the right to update or modify these Terms &amp; Conditions at any time. Changes will be posted on this page with an updated "Last Updated" date. Continued use of the website after any changes constitutes acceptance of the new terms.</p>

      <h3>13. Governing Law &amp; Jurisdiction</h3>
      <p>These terms are governed by and construed in accordance with the laws of India. Any disputes arising out of or relating to these terms shall be subject to the exclusive jurisdiction of the courts in Jaipur, Rajasthan, India.</p>

      <h3>14. Contact</h3>
      <p>For questions about these Terms &amp; Conditions:</p>
      ` + CONTACT_BLOCK + `
    `
  },
  refund: {
    title: 'Return & Refund Policy',
    content: `
      <p><strong>Last Updated:</strong> 22 March 2026</p>
      <p>At <strong>Decant Diaries</strong>, customer satisfaction is important to us. Please read this policy carefully before initiating a return, refund, or exchange.</p>

      <h3>Returns</h3>
      <p>You may request a return within <strong>7 days of delivery</strong>, subject to the following conditions:</p>
      <ul>
        <li>Products must be <strong>unused, unopened, and in original condition</strong></li>
        <li>All original packaging, seals, and accessories must be intact</li>
        <li>Items showing signs of use, tampering, or damage will not be eligible for return</li>
      </ul>
      <p>To initiate a return, please email <a href="mailto:support@decantdiaries.in">support@decantdiaries.in</a> or message us on <a href="https://wa.me/916378345040" target="_blank">WhatsApp</a> with your order number. Our team will share the return instructions.</p>

      <h3>Exchanges</h3>
      <ul>
        <li>Exchange requests must be made within <strong>7 days of delivery</strong></li>
        <li>Exchanges are processed only after the returned item is received and verified</li>
        <li>Any price difference between products will be adjusted accordingly</li>
      </ul>

      <h3>Refunds</h3>
      <ul>
        <li>Once the returned product is received and inspected, the refund will be processed to the <strong>original payment method</strong></li>
        <li>Refunds are initiated within <strong>5-7 business days</strong> after successful verification</li>
        <li>Shipping charges, if applicable, are <strong>non-refundable</strong></li>
      </ul>

      <h3>Damaged or Incorrect Products</h3>
      <p>If you receive a damaged, defective, or incorrect product, please contact us within <strong>48 hours of delivery</strong> with clear photographs.</p>
      <p>Upon verification, we will arrange a <strong>replacement, exchange, or refund</strong> at no additional cost.</p>

      <h3>Non-Returnable Items</h3>
      <p>Due to hygiene and safety reasons, <strong>used or partially used fragrance products are not eligible for return or exchange</strong>, unless the issue is related to damage, leakage, or incorrect delivery.</p>

      <h3>Important Notes</h3>
      <ul>
        <li>Requests raised after <strong>7 days from delivery</strong> will not be accepted</li>
        <li>Refunds and exchanges are processed only after the returned item is received and verified</li>
        <li>Decant Diaries reserves the right to reject returns that do not meet the above conditions</li>
      </ul>

      <h3>Contact Us</h3>
      <p>For any questions regarding returns, refunds, or exchanges:</p>
      ` + CONTACT_BLOCK + `
    `
  },
  shipping: {
    title: 'Shipping Policy',
    content: `
      <p><strong>Last Updated:</strong> 22 March 2026</p>

      <h3>Shipping Coverage</h3>
      <p>We currently ship across India only. International shipping is not available at this time.</p>

      <h3>Shipping Costs</h3>
      <ul>
        <li>A flat shipping charge of <strong>Rs. 250</strong> applies to orders below ₹5,000 (excluding COD charges, taxes, or discounts).</li>
        <li>Orders above <strong>₹5,000 qualify for free shipping.</strong></li>
        <li><strong>Cash on Delivery (COD) is not available.</strong></li>
        <li>Shipping charges are non-refundable in case of returns or cancellations.</li>
        <li>Decant Diaries reserves the right to modify shipping charges without prior notice. Updated charges will be reflected at checkout.</li>
      </ul>

      <h3>Shipping Partners &amp; Delivery Times</h3>
      <ul>
        <li>We primarily use <strong>Blue Dart</strong> for deliveries.</li>
        <li>If your area is not serviceable by Blue Dart, we may use alternate partners like <strong>Delhivery</strong> or <strong>DTDC</strong>.</li>
        <li>Standard delivery takes <strong>4-5 business days</strong> (excluding Sundays and holidays).</li>
        <li>Perfume decants are prepared to order. This may add <strong>2-4 days</strong> to your shipping time.</li>
        <li>While Decant Diaries strives to fulfil orders by the estimated delivery date, unforeseen logistical challenges may cause delays. We kindly request your patience in such instances as we work to resolve them.</li>
      </ul>

      <h3>Packaging</h3>
      <p>All decants are carefully packaged in bubble wrap and sturdy boxes to prevent damage or leakage during transit. Each decant comes in a premium glass atomizer with a secure spray mechanism.</p>

      <h3>Order Tracking</h3>
      <p>Once your order is dispatched, we will share the tracking ID and courier details via WhatsApp so you can track your shipment in real time.</p>

      <h3>Delivery Issues</h3>
      <p>If your order is delayed beyond 10 business days, or if the package arrives damaged, please contact us immediately.</p>

      <h3>Undeliverable Orders</h3>
      <p>If an order is returned to us due to an incorrect address, failed delivery attempts, or refusal to accept, the customer will be responsible for reshipping charges. We will contact you to arrange redelivery.</p>

      <h3>Contact</h3>
      <p>For any shipping-related queries:</p>
      ` + CONTACT_BLOCK + `
    `
  }
};

function openPolicy(key) {
  const p = policies[key];
  if (!p) return;
  document.getElementById('policyTitle').textContent = p.title;
  document.getElementById('policyBody').innerHTML = p.content;
  document.getElementById('policyOverlay').classList.add('open');
  document.body.style.overflow = 'hidden';
}
function closePolicy() {
  document.getElementById('policyOverlay').classList.remove('open');
  document.body.style.overflow = '';
}
// Escape key for policy modals handled by unified handler above

// ─── COOKIE CONSENT ───
(function() {
  const banner = document.getElementById('cookieBanner');
  const consent = localStorage.getItem('dd_cookie_consent');
  if (!consent) {
    setTimeout(() => banner.classList.add('visible'), 2000);
  } else if (consent === 'accepted') {
    enableTracking();
  }
})();

function handleCookieConsent(accepted) {
  const banner = document.getElementById('cookieBanner');
  banner.classList.remove('visible');
  localStorage.setItem('dd_cookie_consent', accepted ? 'accepted' : 'declined');
  if (accepted) enableTracking();
}

function enableTracking() {
  // Enable Google Analytics & Ads tracking
  if (typeof gtag === 'function') {
    gtag('consent', 'update', {
      'analytics_storage': 'granted',
      'ad_storage': 'granted',
      'ad_user_data': 'granted',
      'ad_personalization': 'granted'
    });
  }
  // Enable Meta Pixel tracking
  if (typeof fbq === 'function') {
    fbq('consent', 'grant');
  }
}

// ─── CONVERSION TRACKING HELPERS ───
// Call these when relevant user actions occur
function trackAddToCart(product, size, price) {
  // Google Ads
  if (typeof gtag === 'function') {
    gtag('event', 'add_to_cart', {
      currency: 'INR',
      value: price,
      items: [{ item_name: product.title, item_brand: product.brand, item_category: product.type, price: price, quantity: 1 }]
    });
  }
  // Meta Pixel
  if (typeof fbq === 'function') {
    fbq('track', 'AddToCart', {
      content_name: product.title,
      content_category: product.brand,
      content_type: 'product',
      value: price,
      currency: 'INR'
    });
  }
}

function trackViewContent(product) {
  if (typeof gtag === 'function') {
    gtag('event', 'view_item', {
      currency: 'INR',
      value: product.prices ? Object.values(product.prices)[0] : 0,
      items: [{ item_name: product.title, item_brand: product.brand, item_category: product.type }]
    });
  }
  if (typeof fbq === 'function') {
    fbq('track', 'ViewContent', {
      content_name: product.title,
      content_category: product.brand,
      content_type: 'product',
      value: product.prices ? Object.values(product.prices)[0] : 0,
      currency: 'INR'
    });
  }
}

function trackInitiateCheckout(product, size, price) {
  if (typeof gtag === 'function') {
    gtag('event', 'begin_checkout', {
      currency: 'INR',
      value: price,
      items: [{ item_name: product.title, item_brand: product.brand, price: price }]
    });
  }
  if (typeof fbq === 'function') {
    fbq('track', 'InitiateCheckout', {
      content_name: product.title,
      value: price,
      currency: 'INR',
      num_items: 1
    });
  }
}
